$(function(){
    if (typeof step !== 'undefined' && step < 5) {
        // Level 2 - 6
        for (var i = 0; i < 10; i++) {
            for (var j = 0; j <= 2; j++) {
                $('#step' + step + 'Question' + i + '_' + j).click(function () {
                    console.log(step + ' ' + i);
                    $('#errorAlert').hide();
                    for (var k = 0; k < 10; k++) {
                        $('#questionRow' + k).children('td').css("color", "black");
                    }
                });
            }
        }

        $('#stepSubmit').click(function() {
            for (var i = 0; i < 10; i++) {
                var val = $('input[name=step' + step + 'Question' + i +']:checked').val();
                if (typeof val === "undefined") {
                    $('#errorAlert').show();
                    $('#questionRow' + i).children('td').css( "color", "red" );
                    return false;
                }
            }
            return true;
        });

    } else if (typeof step !== 'undefined' && step === 5) {
        // Level 7 special case
        $('#step7Submit').click(function() {
            for (var i = 0; i < 10; i++) { // looping through the 10 questions
                var mes = 0;
                var notmes = 0;
                for (var j = 0; j < 3; j++) { // looping through 3 possible answers
                    var checkbox = $('#step5Question' + i + '_R' + j + '_C0'); // "ME" answer
                    if (checkbox.length && checkbox.is(':checked')) {
                        mes++;
                    }
                    checkbox = $('#step5Question' + i + '_R' + j + '_C2'); // "NOT ME" answer
                    if (checkbox.length && checkbox.is(':checked')) {
                        notmes++;
                    }
                }
                if (mes !== 1 || notmes !== 1) {
                    $('#errorAlert').show();
                    $('#question' + i + ' td').css( "color", "red" );
                    return false;
                }
            }
            return true;
        });
    }

    $('#emailForm').click(function() {
        $('#errorAlert').hide();
    });

    $('#emailSubmit').click(function() {
        if (!isEmail($('#emailForm').val())) {
            $('#errorAlert').show();
            return false;
        }
        return true;
    });
});

// This function enforces the "ME" / "NOT ME" forced choice in Value Level 7 questions
function checkboxMagic(checkBox, fname, row, col, rows) {
    // Enforce vertical rules
    $('#errorAlert').hide();
    for (var i = 0; i < 10; i++) {
        $('#question' + i + ' td').css( "color", "black" );
    }
    if (checkBox.checked) {
        for(var i = 0; i < rows; i++) {
            var compareBox = document.getElementById(fname + '_R' + i + '_C' + col);
            if (row != i && compareBox.checked) {
                checkBox.checked = false;
            }
        }
    }
    // Enforce horizontal rules
    if (checkBox.checked) {
        for(var j = 0; j <= 2; j++) {
            if (col != j) {
                var uncheckBox = document.getElementById(fname + '_R' + row + '_C' + j);
                uncheckBox.checked = false;
            }
        }
    }
}

function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
}